export default "__VITE_ASSET__BS1NchrN__"